module.exports = __webpack_public_path__ + "img/actver.19dfdb60.png";